import React from "react";
import FeatureCard from "../../../common/feature-card/FeatureCard";
import { useTranslation } from "react-i18next";

const CategoryLengthTypes = ({
  data,
  img,
  onLookupClick,
  isVisible = true,
  one_length_book,
  toolId,
}) => {
  const { t } = useTranslation();
  const key = "category_length_types";

  let filteredItems =
    data?.[key]?.filter((item) => Boolean(item.new_book) !== one_length_book) ||
    [];

  if (one_length_book) return null;

  return (
    <div
      style={
        isVisible
          ? { height: "auto", visibility: "visible" }
          : { height: "0px", visibility: "hidden" }
      }
    >
      {filteredItems?.length > 0 && (
        <div id={key + "-title-id"}>
          <div className="row mt-3">
            <div className="col-12 mb-3">
              <h4 className="section-desc">{t("how_long_is_your_story")}?</h4>
            </div>
            <div className="col-lg-4 col-md-6" />
          </div>
          <div className="row">
            {filteredItems.map((item, index) => (
              <FeatureCard
                key={key + "-" + index}
                onClick={onLookupClick(key, item)}
                name={item?.name}
                description={item?.description}
                is_selected={item?.is_selected}
                showArrow={false}
                variant="general-categories-options"
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryLengthTypes;
